module.exports = __webpack_public_path__ + "img/51_28.6d97f301.png";